import request from './request';

import { ENDPOINT } from '../../constants/api';
import { EXT } from '../../constants/photos';

const photoEditor = {
  applyCustomBackground({ background, db, format = EXT.WEBP, image, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);
    payload.append('ref_image_url', background);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/customBackground`,
    });
  },
  backgroundPromptSuggestion({ db, format = EXT.WEBP, image, prompt, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);

    if (prompt) {
      payload.append('user_prompt', prompt);
    }

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/aiPromptSuggestion`,
    });
  },
  changeBackground({ background, color, db, format = EXT.WEBP, image, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);

    if (background) {
      payload.append('bg_image_url', background);
    }

    if (color) {
      payload.append('bg_color', color);
    }

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/changeBackground`,
    });
  },
  editImage({ count = 3, db, format = EXT.JPEG, image, prompt, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);
    payload.append('prompt', prompt);
    payload.append('count', count);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/aiEditImage`,
    });
  },
  enhance({ db, format = EXT.WEBP, image, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/polishAndUpscale`,
    });
  },
  expand({ db, format = EXT.WEBP, image, shopId, signal, size }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);
    payload.append('width', size.width);
    payload.append('height', size.height);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/outpaint`,
    });
  },
  generateBackground({ count = 1, db, format = EXT.WEBP, image, model, prompt, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);
    payload.append('prompt', prompt);
    payload.append('model', model);
    payload.append('count', count);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/aiBackground`,
    });
  },
  generateVideo({ db, duration, format = EXT.WEBP, image, prompt, shopId, signal }) {
    const payload = new FormData();
    payload.append('duration', duration);
    payload.append('format', format);
    payload.append('image_file', image);
    payload.append('prompt', prompt);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/generateVideo`,
    });
  },
  getAIImageEditStatus({ db, shopId, jobId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/aiEditImageStatus/${jobId}`,
    });
  },
  getVideoGenerationStatus({ db, shopId, jobId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/videoStatus/${jobId}`,
    });
  },
  getColorSuggestions({ count = 7, db, image, shopId, signal }) {
    const payload = new FormData();
    payload.append('image_file', image);
    payload.append('count', count);

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/aiColorSuggestions`,
    });
  },
  imageToVideoPromptSuggestion({ db, format = EXT.WEBP, image, prompt, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);

    if (prompt) {
      payload.append('user_prompt', prompt);
    }

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/imageToVideoPromptSuggestion`,
    });
  },
  removeBackground({ color, db, format = EXT.WEBP, image, shopId, signal }) {
    const payload = new FormData();
    payload.append('format', format);
    payload.append('image_file', image);

    if (color) {
      payload.append('color', color);
    }

    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/aiPhotoEditor/shops/${shopId}/removeBackground`,
    });
  },
  unsplashDownload({ downloadLocation, signal }) {
    return request.post({
      payload: { downloadLocationUrl: downloadLocation },
      signal,
      url: '/shops/unsplash/download',
    });
  },
  unsplashSearch({ page, query, signal }) {
    return request.get({
      params: { searchQuery: query, page: (page || 0) + 1, pageSize: 10 },
      signal,
      url: '/shops/unsplash/search',
    });
  },
};

export default photoEditor;
